import { render, staticRenderFns } from "./recipients-table.vue?vue&type=template&id=610379f8&"
import script from "./recipients-table.vue?vue&type=script&lang=js&"
export * from "./recipients-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports